import React from 'react'
import { DocumentacionReclamoExterno } from '../StepperIngreso/DocumentacionReclamoExterno'

export const DocumentacionReclamoExternoMenu = ({ solicitud, disabled }) => {
  return (
    <DocumentacionReclamoExterno solicitud={solicitud} disabled={disabled} />
  )
}
